import Yup from '@fourthwall/utils/dist/yup';
export const validationSchema = Yup.object().shape({
    additionalSections: Yup.array().of(Yup.object().shape({
        title: Yup.string().required(),
        bodyHtml: Yup.string()
            .max(4_096 - 1, ({ max }) => `Must have less than ${max + 1} HTML characters.`)
            .required(),
    })),
});
